import { atom } from "recoil";

const filtroTareaState = atom({
    key: "filtroTareaState", // unique ID (with respect to other atoms/selectors)
    default: false // default value (aka initial value)
  });
  export default filtroTareaState;
  